module.exports = __webpack_public_path__ + "img/ka2-2.dcc1d1cc.png";